import { render, staticRenderFns } from "./FieldNew.vue?vue&type=template&id=61b80a5d"
import script from "./FieldNew.vue?vue&type=script&lang=js"
export * from "./FieldNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports